(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-product"] && !Shopify.designMode) return;
  try {
    
  // Confort d'affichage uniquement : le formulaire reste fonctionnel sans ce
  // script, puisque chaque pastille porte déjà l'identifiant de sa variante.
  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-pp-variant]');
    if (!input) return;

    const root = input.closest('[data-pp-product]');
    if (!root) return;

    const name = root.querySelector('[data-pp-variant-name]');
    if (name) name.textContent = input.dataset.name;

    const price = root.querySelector('[data-pp-price]');
    if (price && input.dataset.price) price.textContent = input.dataset.price;

    const image = root.querySelector('[data-pp-image]');
    if (image && input.dataset.image) {
      image.removeAttribute('srcset');
      image.src = input.dataset.image;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
